import React from "react";
import { type IIconInterface } from "../icon.interface";
import { SvgIcon } from "../SvgIcon";

export const MapPinIcon: React.FC<IIconInterface> = (props): JSX.Element => {
  return (
    <SvgIcon title="MapPin" viewBox="0 0 35 64" {...props}>
      <circle
        cx="18"
        cy="57"
        fill="white"
        r="5"
        stroke="#0E5AA7"
        strokeWidth="2"
      />
      <path
        clipRule="evenodd"
        d="M31.2909 24.4926C32.3883 22.378 33 19.8821 33 17.0769C33 10.2641 26.956 2 16.6226 2C6.77673 2 2 10.9494 2 17.7622C2 19.7052 2.56715 21.7105 3.58028 23.5845C3.98532 24.6085 4.70428 26.0021 5.99686 28.042C13.7956 38.3217 15.3679 44.1853 18 57.5C20.7296 44.2832 22.0858 37.8322 29.2956 28.042C30.0769 26.981 30.7527 25.8158 31.2909 24.4926ZM17.5 21.8741C20.7842 21.8741 23.4465 19.2004 23.4465 15.9021C23.4465 12.6038 20.7842 9.93007 17.5 9.93007C14.2158 9.93007 11.5535 12.6038 11.5535 15.9021C11.5535 19.2004 14.2158 21.8741 17.5 21.8741Z"
        fill="#DD2326"
        fillRule="evenodd"
      />
    </SvgIcon>
  );
};
